import { useState } from "react";
import API from "../../../../utils/api";


export const useMuwePayment = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const submitCardPaymentMuwe = async (data) => {
    setIsSubmitting(true);
    try {
      const response = await API.submitCardPaymentMuwe(data);
      return response.data;
    } catch (error) {
      setError(error);
    }
    finally {
      setIsSubmitting(false);
    }
  };

  return {
    isSubmitting,
    error,
    submitCardPaymentMuwe,
  };
};